import axios from 'axios'


export const getMapValAndUpdateIfNotExist = async (storeMap, key, apifunc) => {
  // mapの中に値があれば素直にそれを返す
  const retValue = storeMap.get(key)
  if(retValue != undefined){
    return {
      getinfo: retValue,
      isUpdate: false
    }
  }
  // 無ければAPIから取得して値を返す
  const fetchValue = await apifunc(key)
  return {
    getinfo: fetchValue,
    isUpdate: true
  }
}


export const fetchOGPInfoFromAPI = async (url) => {
  const API_URL = "https://asia-northeast1-interimadd-twitter-api.cloudfunctions.net/get_ogp"
  const apiParam = { params: { url: url} }
  try{
    const res = await axios.get(API_URL, apiParam)
    const ogpInfo = res.data
    const retInfo = {
      "title": ogpInfo["og:title"],
      "url": ogpInfo["og:url"],
      "image":ogpInfo["og:image"]
    }
    return retInfo
  } catch(e) {
    return e
  }
}


export const fetchTweetByIdFromAPI = async (tweetId, accessToken, accessTokenSecret) => {
  const api_url = "https://asia-northeast1-interimadd-twitter-api.cloudfunctions.net/get_tweet_by_id"
  const tweet_info = await axios.get(api_url, {
    params: {
      id: tweetId,
      at: accessToken,
      ats: accessTokenSecret,
    }
  })
  const tweetObj = tweet_info.data 
  if(!("id" in tweetObj)) return {}  // 正常に読めてないっぽいとき
  return tweetObj
}


export const fetchUserInfoByName = async (username, accessToken, accessTokenSecret) => {
  const api_url = "https://asia-northeast1-interimadd-twitter-api.cloudfunctions.net/get_user_info"
  const tweet_info = await axios.get(api_url, {
    params: {
      username: username,
      at: accessToken,
      ats: accessTokenSecret,
    }
  })
  const tweetObj = tweet_info.data 
  if(!("id" in tweetObj)) return {}  // 正常に読めてないっぽいとき
  return tweetObj
}


export const fetchUserInfoById = async (userid, accessToken, accessTokenSecret) => {
  const api_url = "https://asia-northeast1-interimadd-twitter-api.cloudfunctions.net/get_user_info"
  const tweet_info = await axios.get(api_url, {
    params: {
      userid: userid,
      at: accessToken,
      ats: accessTokenSecret,
    }
  })
  const tweetObj = tweet_info.data 
  if(!("id" in tweetObj)) return {}  // 正常に読めてないっぽいとき
  return tweetObj
}
